import React from 'react';
import { Link } from 'react-router-dom'; // Import Link

const PrivacyPolicy: React.FC = () => {
  return (
    // Use the static-content-page class for consistent styling and alignment
    <div className="static-content-page">
      <h1>Privacy Policy</h1>
        <p>
          At IntelPro, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal data.
        </p>
        <h2>What Data We Collect</h2>
        <p>
          We may collect personal data such as your name, email address, company, role, and any other information you provide through our contact forms.
        </p>
        <h2>How We Use Your Data</h2>
        <p>
          Your data is used to respond to inquiries, provide services, and improve our website. We do not share your data with third parties without your consent.
        </p>
        <h2>Your Rights</h2>
        <p>
          You have the right to access, correct, or delete your personal data. To exercise these rights, please contact us
          {/* Replace mailto link with internal Link */}
          &nbsp;via our <Link to="/contact">Contact Page</Link>.
        </p>
        <h2>Cookies</h2>
        <p>
          We use cookies to enhance your experience on our website. You can manage your cookie preferences through your browser settings.
        </p>
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us via our <Link to="/contact">Contact Page</Link>.
        </p>
    </div>
  );
};

export default PrivacyPolicy;